import React from "react"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { CHART_COLORS } from "@react/projects/chantiers_dashboard/components/palette"

const SegmentsCard = ({ data, currency }) => {
  const rows  = data || []
  const money = (cents) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format((cents || 0) / 100)

  return (
    <ChartCard
      icon     = "layer-group"
      title    = {I18n.t("contracts_dashboard.charts.segments")}
      subtitle = {I18n.t("contracts_dashboard.charts.segments_hint")}
      height   = {280}
      empty    = {rows.every((row) => row.count === 0) ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <div className="px-5 py-3 space-y-2.5 overflow-auto h-full">
        {rows.map((row, index) => (
          <div key={row.id}>
            <div className="flex items-baseline justify-between text-[12px]">
              <span className="font-semibold text-slate-800">{row.label}</span>
              <span className="tabular-nums text-slate-500">
                {I18n.t("contracts_dashboard.charts.contracts_count", { count: row.count })} · {money(row.value)}
              </span>
            </div>
            <div className="mt-1 h-2 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full rounded-full"
                   style={{ width: `${row.share}%`, background: CHART_COLORS[index % CHART_COLORS.length] }} />
            </div>
            <div className="mt-0.5 text-[10.5px] text-slate-400 tabular-nums">{row.share} %</div>
          </div>
        ))}
      </div>
    </ChartCard>
  )
}

export default SegmentsCard
